export const GET_LIST_REKOMENDASI_BRIDAYA = 'BridayaGetRecommendations/Success';
export const LOADING_GET_LIST_REKOMENDASI_BRIDAYA =
  'BridayaGetRecommendations/Loading';
export const GET_LIST_TINDAK_LANJUT_BRIDAYA = 'BridayaGetTindakLanjut/Success';
export const LOADING_GET_LIST_TINDAK_LANJUT_BRIDAYA =
  'BridayaGetTindakLanjut/Loading';
export const GET_DETAIL_REKOMENDASI_BRIDAYA =
  'BridayaGetDetailRecommendation/Success';
export const LOADING_GET_DETAIL_REKOMENDASI_BRIDAYA =
  'BridayaGetDetailRecommendation/Loading';
export const GET_DETAIL_DITINDAKLANJUTI_BRIDAYA =
  'BridayaGetDetailDitindaklanjuti/Success';
export const LOADING_GET_DETAIL_DITINDAKLANJUTI_BRIDAYA =
  'BridayaGetDetailDitindaklanjuti/Loading';
export const GET_DESKRIPSI_BRIDAYA = 'BridayaOnboardDeskripsi/Success';
export const LOADING_DESKRIPSI_BRIDAYA = 'BridayaOnboardDeskripsi/Loading';
export const INFINITE_SCROLL_REKOMENDASI_BRIDAYA =
  'BridayaInfiniteScroll/Success';
export const LOADING_INFINITE_SCROLL_REKOMENDASI_BRIDAYA =
  'BridayaInfiniteScroll/Loading';
export const INFINITE_SCROLL_TINDAKLANJUT_BRIDAYA =
  'BridayaInfiniteScrollTindakLanjut/Success';
export const LOADING_INFINITE_SCROLL_TINDAKLANJUT_BRIDAYA =
  'BridayaInfiniteScrollTindakLanjut/Loading';

export const POST_SUBMIT_TL_AKAN_MENGUNJUNGI =
  'BridayaSubmitTLAkanMenjungi/Success';
export const LOADING_SUBMIT_TL_AKAN_MENGUNJUNGI =
  'BridayaSubmitTLAkanMenjungi/Loading';

export const POST_SUBMIT_TL_TIDAK_MENGUNJUNGI =
  'BridayaSubmitTLTidakMengunjungi/Success';
export const LOADING_SUBMIT_TL_TIDAK_MENGUNJUNGI =
  'BridayaSubmitTLTidakMengunjungi/Loading';

export const POST_SUBMIT_TL_TIDAK_TERTARIK =
  'BridayaSubmitTLTidakTertarik/Success';
export const LOADING_SUBMIT_TL_TIDAK_TERTARIK =
  'BridayaSubmitTLTidakTertarik/Loading';

export const IS_APPEAR_SNACKBAR_LOLOS = 'BridayaAppearingSnackbarLolos/Success';
export const IS_APPEAR_SNACKBAR_TIDAK_LOLOS =
  'BridayaAppearingSnackbarTidakLolos/Success';

export const GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI =
  'BridayaGetListAlasanTidakDapatDihubungi/Success';
export const LOADING_GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI =
  'BridayaGetListAlasanTidakDapatDihubungi/Loading';

export const GET_LIST_ALASAN_TIDAK_COCOK =
  'BridayaGetListAlasanTidakCocok/Success';
export const LOADING_GET_LIST_ALASAN_TIDAK_COCOK =
  'BridayaGetListAlasanTidakCocok/Loading';

export const POST_SUBMIT_TL_TIDAK_DAPAT_DIHUBUNGI_TIDAK_DIKUNJUNGI =
  'BridayaSubmitTLTidakDapatDihubungiTidakDikunjungi/Success';
export const LOADING_SUBMIT_TL_TIDAK_DAPAT_DIHUBUNGI_TIDAK_DIKUNJUNGI =
  'BridayaSubmitTLTidakDapatDihubungiTidakDikunjungi/Loading';

export const POST_SUBMIT_TL_TIDAK_COCOK = 'BridayaSubmitTLTidakCocok/Success';
export const LOADING_SUBMIT_TL_TIDAK_COCOK =
  'BridayaSubmitTLTidakCocok/Loading';

export const POST_SUBMIT_TL_OTHER_CASE = 'BridayaSubmitTLOtherCase/Success';
export const LOADING_SUBMIT_TL_OTHER_CASE = 'BridayaSubmitTLOtherCase/Loading';

export const POST_SUBMIT_TL_TK_TERTARIK = 'BridayaSubmitTLTKTertarik/Success';
export const LOADING_SUBMIT_TL_TK_TERTARIK =
  'BridayaSubmitTLTKTertarik/Loading';

export const POST_SUBMIT_TL_TK_OTHER_CASE =
  'BridayaSubmitTLTKOtherCaselanjutan/Success';
export const LOADING_SUBMIT_TL_TK_OTHER_CASE =
  'BridayaSubmitTLTKOtherCaselanjutan/Loading';

// Pemberdayaan section
export const GET_LIST_PEMBERDAYAAN_BRIDAYA = 'BridayaGetPemberdayaan/Success';
export const LOADING_GET_LIST_PEMBERDAYAAN_BRIDAYA =
  'BridayaGetPemberdayaan/Loading';
export const GET_DETAIL_PEMBERDAYAAN_BRIDAYA =
  'BridayaGetDetailPemberdayaan/Success';
export const LOADING_GET_DETAIL_PEMBERDAYAAN_BRIDAYA =
  'BridayaGetDetailPemberdayaan/Loading';
export const INFINITE_SCROLL_PEMBERDAYAAN_BRIDAYA =
  'BridayaInfiniteScrollPemberdayaan/Success';
export const LOADING_INFINITE_SCROLL_PEMBERDAYAAN_BRIDAYA =
  'BridayaInfiniteScrollPemberdayaan/Loading';
export const GET_LIST_ALASAN_LOLOS_PEMBERDAYAAN_BRIDAYA =
  'BridayaGetAlasanLolosPemberdayaan/Success';
export const LOADING_GET_LIST_ALASAN_LOLOS_PEMBERDAYAAN_BRIDAYA =
  'BridayaGetAlasanLolosPemberdayaan/Loading';
export const SUBMIT_LOLOS_PEMBERDAYAAN_1_BRIDAYA =
  'BridayaSubmitLolosPemberdayaan1/Success';
export const LOADING_SUBMIT_LOLOS_PEMBERDAYAAN_1_BRIDAYA =
  'BridayaSubmitLolosPemberdayaan1/Loading';
export const SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_1_BRIDAYA =
  'BridayaSubmitTidakLolosPemberdayaan1/Success';
export const FINISH_SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_1_BRIDAYA =
  'BridayaSubmitTidakLolosPemberdayaan1/Loading';
export const UPDATE_LOLOS_PEMBERDAYAAN =
  'BridayaUpdateLolosPemberdayaan1/Success';

 // ???
export const FINIS_POST_SUBMIT_TL_AKAN_MENGUNJUNGI = 'test'

export const SUBMIT_LOLOS_PEMBERDAYAAN_2_BRIDAYA =
  'BridayaSubmitLolosPemberdayaan2/Success';
export const LOADING_SUBMIT_LOLOS_PEMBERDAYAAN_2_BRIDAYA =
  'BridayaSubmitLolosPemberdayaan2/Loading';
export const SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_2_BRIDAYA =
  'BridayaSubmitTidakLolosPemberdayaan2/Success';
export const LOADING_SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_2_BRIDAYA =
  'BridayaSubmitTidakLolosPemberdayaan2/Loading';


 // Filter user
export const GET_LIST_USER_FILTER_BRIDAYA = 'BridayaUserFilter/Success'
export const LOADING_LIST_USER_FILTER_BRIDAYA = 'loadingBridayaUserFilter/Success';
